export function getCurrentYear() {
  const year = new Date().getFullYear();
  return Number(`1${year}0101`);
}